import './styles.scss'
import routes from '../routes'
import { NavLink } from 'react-router-dom'
import logo from '../images/SRL_ID_Horiz_Green.svg'
import hamburgerIcon from '../images/hamburgerIcon.svg'
import { useState } from 'react'
import classNames from 'classnames'

export default function Header(props) {
  const { toggleModal, headerVisible } = props
  const [menuOpen, setMenuOpen] = useState(false)
  return (
    <header className={classNames("Header", { headerVisible })}>
      <span className='title'>
        <a href="https://savetheredwoods.org">
          <img src={logo} alt='save the redwoods' />
        </a>
        <h1>Dedicated Groves</h1>
      </span>
      <nav className={classNames('desktop', { open: menuOpen })} >
        {routes.map(route => {
          if (!route.label) {
            return null
          }
          const onClick = (e) => {
            if (menuOpen) {
              setMenuOpen(false)
            }
            if (route.modal) {
              toggleModal(route)
              e.preventDefault()
            }
          }
          if (route.component === null) {
            return <a href={route.link} >{route.label}</a>
          }
          return (
            <NavLink key={route.link || route.path} to={route.link || route.path} exact={route.exact} onClick={onClick}>
              {route.label}
            </NavLink>
          )}
        )}
      </nav>
      <img className='menuIcon' src={hamburgerIcon} onClick={e => setMenuOpen(true)} alt='menu' />

    </header>
  )
}
